// src/api/material.api.ts
import { get, post, put, del, patch } from './client';

export const materialApi = {
  // Get all materials (paginated)
  getAllMaterials: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    category?: string;
    sortBy?: string;
    sortOrder?: string;
  }) => get('/materials', { params }),

  // Get material by ID
  getMaterialById: (id: string) => get(`/materials/${id}`),

  // Create material
  createMaterial: (data: {
    name: string;
    quantity?: number;
    price?: number;
    unitType: string;
    category?: string | null;
    lowStockThreshold?: number | null;
  }) => post('/materials', data),

  // Update material
  updateMaterial: (id: string, data: {
    name?: string;
    price?: number;
    unitType?: string;
    category?: string | null;
    lowStockThreshold?: number | null;
    isActive?: boolean;
  }) => put(`/materials/${id}`, data),

  // Delete material
  deleteMaterial: (id: string) => del(`/materials/${id}`),

  // Restock material (add quantity)
  restockMaterial: (id: string, data: { quantity: number; price?: number; notes?: string; effectiveDate?: string | null }) =>
    patch(`/materials/${id}/restock`, data),

  // Adjust stock (set quantity)
  adjustStock: (id: string, data: { newQuantity: number; notes?: string }) =>
    patch(`/materials/${id}/adjust`, data),

  // Get inventory summary
  getInventorySummary: () => get('/materials/summary'),

  // Get low stock materials
  getLowStockMaterials: () => get('/materials/low-stock'),

  // Get materials needing reconciliation (negative or zero stock with consumption)
  getAnomalies: () => get('/materials/anomalies'),

  // Batch restock multiple materials
  batchRestock: (data: { items: { materialId: string; quantity: number; price?: number; effectiveDate?: string }[] }) =>
    post('/materials/batch-restock', data),

  // Get stock movements for a material
  getStockMovements: (id: string, params?: { page?: number; limit?: number; type?: string }) =>
    get(`/materials/${id}/movements`, { params }),

  // ===== Category Management =====

  // Get all categories with material counts
  getCategories: () => get('/materials/categories'),

  // Create a new category
  createCategory: (data: { name: string }) => post('/materials/categories', data),

  // Rename a category
  renameCategory: (data: { oldName: string; newName: string }) => put('/materials/categories/rename', data),

  // Delete a category and all its materials
  deleteCategory: (categoryName: string) => del(`/materials/categories/${encodeURIComponent(categoryName)}`),
};

